export default class EventListenerModel {
  #eventListeners = {};

  constructor() {
    this.#eventListeners = {};
  }

  addEventListener(key = "", cb) {
    if (typeof cb !== "function") {
      return;
    }

    const evList = this.#eventListeners[key] || [];

    //Prevents duplicate callbacks from being added
    if (evList.indexOf(cb) >= 0) {
      return;
    }

    evList.push(cb);
    this.#eventListeners[key] = evList;

    console.log("addEventListener", key, cb);
  }

  removeEventListener(key = "", cb) {
    console.log("removeEventListener", key, cb);
    const bRemoveAll = false; //typeof cb === "undefined";
    let evList = this.#eventListeners[key] || [];

    if (bRemoveAll) {
      console.log("removeEventListener.removeAll", key);
      this.#eventListeners[key] = [];
      return;
    }
    const idx = evList.indexOf(cb);
    if (idx >= 0) {
      evList = evList.splice(idx, 1);
    }

    this.#eventListeners[key] = evList;
  }

  processEventListener(key = "", ...args) {
    const evList = this.#eventListeners[key] || [];
    console.log("processEventListener", key, evList, this.#eventListeners);
    for (let i = 0; i < evList.length; i++) {
      if (typeof evList[i] !== "function") {
        continue;
      }
      evList[i](...args);
    }
  }
}
